<template>
 <v-dialog
            v-model="dialog"
            width="800"
            persistent
        >
            <v-form ref="form">
                <v-card :loading="loading">
                    <v-card-title v-if="!deadlineOnly">
                        <span class="headline">{{ 'Motivo da prioridade' | translate('Situacaoes')}} </span>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                        <v-container>
                            <v-row v-if="!deadlineOnly">
                                <v-col>
                                    <v-textarea
                                        outlined
                                        :label="'Justificativa' | translate('Situacaoes')"
                                        v-model="reason"
                                    >
                                    </v-textarea>
                                </v-col>
                            </v-row>
                            <v-card-title>
                                <span  style="color:black;" class="headline">{{ 'Prazo' | translate('Situacaoes')}} </span>
                            </v-card-title>
                            <v-row>
                                
                                <!-- <v-col cols="4" >
                                    <v-radio-group
                                          v-model="deadlineOption"
                                          row
                                    >
                                          <v-radio
                                              label="Patch"
                                              value="patch"
                                          ></v-radio>
                                          <v-radio
                                              label="Data limite"
                                              value="date"
                                      ></v-radio>
                                    </v-radio-group>
                                </v-col> -->
                                <!-- <v-col v-if="this.deadlineOption == 'patch'">
                                    <v-text-field type="number" label="Insira o patch" v-model='deadlinePatch'>
                                    </v-text-field>
                                </v-col> -->
                                <v-col
                                    cols="12"
                                    sm="6"
                                    md="4"
                                >
                                <v-dialog
                                    v-model="modal"
                                    width="290px"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="deadlineDate"
                                        label="Data limite para entrega"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                    ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="deadlineDate"
                                        color="black"
                                        scrollable
                                    >
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        text
                                        color="black"
                                        @click="modal = false"
                                    >
                                        OK
                                    </v-btn>
                                    </v-date-picker>
                                </v-dialog>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                    <v-spacer></v-spacer>
                        <v-btn
                            class="white--text btn1" 
                            small
                            color="black"
                            @click="closeModal()"
                        >
                            {{'Cancelar' | translate('Atendimento')}}
                        </v-btn>
                        <v-btn 
                            class="white--text btn1" 
                            small
                            color="black"
                            @click="input()"
                        >
                            {{'Salvar' | translate('Atendimento')}}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
    </v-dialog>
</template>
<script>


export default {
    props : {
        deadlineOnly : Boolean
    },
    data() {
        return {
            loading : false,
            reason : '',
            dialog : true,
            deadlineOption : null,
            deadlinePatch : null,
            deadlineDate:'',
            modal : false
        }
    },
    watch:{
        deadlineOption(){
            this.deadlinePatch = null
            this.deadlineDate = null
        }
    },
    methods : {
        input(){
            if(this.deadlineDate){
                let dt = this.deadlineDate.split('-')
                this.deadlineDate = dt[2] + '-' + dt[1] + '-' + dt[0]
            } 
            let obj = {
                deadline : this.deadlineDate,
                patch : this.deadlinePatch,
                motive : this.reason
            }
            this.$emit('input', obj)
        },
        closeModal(){
            this.$emit('close')
        }
    }
}
</script>
